import { ContentImage02 } from './ContentImage02';

export type { TypeContentImage02Props } from './types';
export default ContentImage02;
